<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Raktárközi megrendelések</span>
      <el-button
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        @click="$router.replace('/sales/representative-orders/add')"
        icon="el-icon-plus"
        v-can="'representativeorder.create'"
      >
        Új raktárközi megrendelés
      </el-button>
    </div>
    <div v-loading="loading" style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="representativeOrder/fetchAll"
      />
    </div>
    <representative-order-list/>
    <template v-if="$route.meta.showAddRepresentativeOrderDialog">
      <representative-order-dialog
        type="add"
        :representative-order-id="$route.params.id"
      />
    </template>
    <template v-if="$route.meta.showUpdateRepresentativeOrderDialog">
      <representative-order-dialog
        :representative-order-id="$route.params.id"
        type="update"
      />
    </template>
    <template v-if="$route.meta.showRepresentativeOrderViewDialog">
      <representative-order-dialog
        :representative-order-id="$route.params.id"
        type="view"
      />
    </template>
  </el-card>
</template>

<script>
import RepresentativeOrderList from '../../components/sales/representativeOrders/List';
import RepresentativeOrderDialog from '../../components/sales/representativeOrders/Dialog';
import TableFilter from '../../components/TableFilter';

export default {
  components: {
    RepresentativeOrderList,
    RepresentativeOrderDialog,
    TableFilter,
  },
  data() {
    return {
      loading: false,
      filterConfig: null,
    };
  },
  async mounted() {
    this.loading = true;
    await this.setConfig();
    this.loading = false;
  },
  methods: {
    async setConfig() {
      let storages = this.$store.getters['storage/storages'];
      let users = this.$store.getters['user/users'];
      if (!storages.length) {
        await this.$store.dispatch('storage/fetchAll');
        storages = this.$store.getters['storage/storages'];
      }
      if (!users.length) {
        await this.$store.dispatch('user/fetchAll');
        users = this.$store.getters['user/users'];
      }
      this.filterConfig = [
        {
          type: 'text',
          name: 'receipt_number',
          label: 'Bizonylatszám',
          defaultSearch: true,
        },
        {
          type: 'select',
          options: users,
          name: 'customer_id',
          label: 'Átvevő',
          labelCallback: user => user && `${user.last_name} ${user.first_name} (@${user.username})` || '',
          valueKey: 'id',
        },
        {
          type: 'select',
          options: storages,
          name: 'target_storage_id',
          label: 'Átvevő Raktár',
          labelCallback: storage => storage && storage.name || '',
          valueKey: 'id',
        },
        {
          type: 'date',
          name: 'completed_at',
          label: 'Teljesítés dátuma',
        },
        {
          type: 'select',
          options: [
            {
              label: 'Rögzítve',
              status: 'recorded'
            },
            {
              label: 'Rakodási listán',
              status: 'sent'
            },
            {
              label: 'Elküldve',
              status: 'done'
            },
            {
              label: 'Bevételezésre vár',
              status: 'waiting-for-inward'
            },
            {
              label: 'Lemondva',
              status: 'resigned'
            },
          ],
          name: 'status',
          label: 'Státusz',
          labelCallback: status => status.label,
          valueKey: 'status',
        },
      ];
    },
  },
};
</script>
